import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { applyInitialFoTheme } from '@/layouts/fo/useFoTheme';

import '@/styles/index.css';

applyInitialFoTheme(window.location.pathname);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
